

const TokenKey = 'soptoken';

export function getToken() {
  return $.cookie(TokenKey);
}

export function setToken(token) {
  return $.cookie(TokenKey, token)
}

export function removeToken() {
  $.cookie(TokenKey, "", {expires: 0, path: "/"});
}



// WEBPACK FOOTER //
// ./src/utils/auth.js